var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityLog(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25943 0.235352V1.43457H2.65982C2.55373 1.43457 2.45163 1.47674 2.37662 1.55176C2.3016 1.62677 2.25943 1.72887 2.25943 1.83496V13.835C2.25943 13.941 2.3016 14.0431 2.37662 14.1182C2.45163 14.1932 2.55373 14.2354 2.65982 14.2354H14.6598C14.7659 14.2354 14.868 14.1932 14.943 14.1182C15.018 14.0431 15.0602 13.941 15.0602 13.835V9.73535H16.2594V13.835C16.2594 14.2593 16.0917 14.6667 15.7917 14.9668C15.4916 15.2669 15.0842 15.4346 14.6598 15.4346H2.65982C2.28853 15.4346 1.93086 15.3055 1.64615 15.0723L1.52798 14.9668C1.22793 14.6667 1.06021 14.2593 1.06021 13.835V1.83496C1.06021 1.41061 1.22793 1.00318 1.52798 0.703125L1.64615 0.597656C1.93086 0.364391 2.28853 0.235352 2.65982 0.235352H7.25943Z",
    fill: "#787486",
    stroke: "#787486",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6598 0.235352C15.819 0.235352 15.9711 0.298611 16.0836 0.411133L16.1588 0.501953C16.2242 0.59984 16.2594 0.715546 16.2594 0.834961V4.43457H15.0602V1.43457H12.0602V0.235352H15.6598Z",
    fill: "#787486",
    stroke: "#787486",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3036 0.342621L16.1516 1.1906L6.01179 11.3304L5.16382 10.4824L15.3036 0.342621Z",
    fill: "#787486",
    stroke: "#787486",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLog);
export default __webpack_public_path__ + "static/media/ActivityLog.020d980f143ffaace691ca5c6da85e0b.svg";
export { ForwardRef as ReactComponent };